// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import 'babel-polyfill'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
//import echarts from 'echarts'

import api from './api'
import core from './core'
import chart from './chart'
import './assets/main.css'
import VueClipboard from 'vue-clipboard2'
import Print from 'vue-print-nb'

const echarts = require('echarts')
// const Vue = require('vue')
// const ElementUI = require('element-ui')

window.Vue = Vue
Vue.use(ElementUI)
Vue.prototype.$api = api
Vue.prototype.$core = core
Vue.prototype.$chart = chart
Vue.prototype.$echarts = echarts
Vue.prototype.$copy = VueClipboard

Vue.config.productionTip = false



Vue.use(Print)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js